import { Button } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setToken } from "../../services/Token";

const ReviewTimesheets = () => {
  const navigate = useNavigate();
  const dashBoardReviewData = useSelector(
    (state) => state.dashBoardReview?.pendingtimesheets ?? []
  );

  const renderComponent = () => {
    return dashBoardReviewData.map((each) => {
      return (
        <div className="bg-[#d5eeff] grid grid-cols-5 gap-3 rounded-md p-3 font-medium mr-[3%] text-center items-center justify-items-center">
          <div>{each.employeeName}</div>
          <div>{each.employeeShortId}</div>
          <div>Month: {dayjs(each.currentMonth).format("MMM YYYY")}</div>
          <div>{each.status}</div>
          <Button
            variant="contained"
            onClick={() => {
              setToken("projectsByID", each.employeeId);
              navigate(`/worklogadmin/${each.employeeId}:${each.currentMonth}`);
            }}
          >
            View Full Timesheet
          </Button>
        </div>
      );
    });
  };
  return (
    <>
      <div className="flex flex-col gap-5">
        {dashBoardReviewData.length === 0 ? (
          <div className="flex justify-center items-center mt-[30%] w-[80%] h-[90%]">
            <p className="text-xl">There are no pending timesheets</p>
          </div>
        ):
        (renderComponent())}
      </div>
    </>
  );
};

export default ReviewTimesheets;
